<div class="title">
  Select events
  <span
    ><span class="blue">{{ checkedEvents.selected.total }}</span> /
    {{ eventList.metadata.total }}
  </span>
</div>
<div *ngIf="eventList.data.length" class="input-check-lines-wrapper">
  <div
    class="input-check-line"
    *ngFor="let item of eventList.data"
    (click)="check(item.id)">
    <input type="checkbox" [(ngModel)]="checkedEvents.list[item.id]" />
    <span
      >{{ item.description }} <br />
      {{ item.code }} - {{ item.date | date }}</span
    >
  </div>
</div>

<div class="pager">
  <button
    class="btn-page"
    type="button"
    [ngClass]="{ disabled: eventList.metadata.currentPage - 1 <= 0 }"
    (click)="goto(eventList.metadata.currentPage - 1)">
    <i class="ti ti-angle-left"></i>
  </button>
  <div class="current">
    <span
      >{{ eventList.metadata.currentPage }}/{{
        eventList.metadata.lastPage
      }}</span
    >
  </div>
  <button
    class="btn-page"
    type="button"
    [ngClass]="{
      disabled:
        eventList.metadata.currentPage + 1 > eventList.metadata.lastPage,
    }"
    (click)="goto(eventList.metadata.currentPage + 1)">
    <i class="ti ti-angle-right"></i>
  </button>
</div>
